
import { defineComponent } from "vue";
import { DOCTORS_ROUTE_NAMES } from "@/ts/enum";

import Template from "@/components/Templates/Punalur.vue";
import Doctors from "@/components/Doctors/Template3/index.vue";

export default defineComponent({
  name: DOCTORS_ROUTE_NAMES.DOCTORS_POYANIL_PUNALUR,
  components: {
    Doctors,
    Template,
  },
});
